<template>
  <div class="view box grow">
    <page-headers
      :header="'Rules Whitelist'"
      :breadcrumbs="breadcrumbs"
      :is-border="true"
      documentation="page-whitelist"
      class="box"
    />
    <div class="full-height" v-loading="rulesListReqStatus === 'loading' || rulesWhitelistReqStatus === 'loading'">
      <div class="table-toolbar" v-if="rulesWhitelistReqStatus === 'saved'">
        <table-toolbar
          :key="whitelists.key"
          :search-properties="visibleWhitelistColumns"
          :total-search-properties="whitelistColumns"
          :search-data="whitelists"
          :initial-tags="whitelists.searchTags"
          :reload-component="whitelists.reloadToolbar"
          @update-querydata="updateTableQueryData"
          @refresh-tabledata="refreshTableData"
          @update-columns-data="modifyColumnsData"
        >
          <div slot="local-actions">
            <el-button-group>
              <el-tooltip class="item" effect="dark" content="Whitelist Setup" placement="top" :enterable="false">
                <el-button type="text" class="help-text-button" @click="showWizardHelper = !showWizardHelper">
                  <i class="material-icons c-icon">help_outline</i>
                </el-button>
              </el-tooltip>
              <el-tooltip
                v-if="$allow('rules', 'write')"
                class="item"
                effect="dark"
                content="New Whitelist"
                placement="top"
                :enterable="false"
              >
                <el-dropdown @command="openWhitelistDialog">
                  <el-button type="text" class="icon-text-button">
                    <i class="material-icons c-icon">add</i>
                    <span>New Whitelist</span>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="optionType in whitelistOptions"
                      :key="optionType.name"
                      :command="optionType.name"
                      :class="{ 'display-none': optionType.name === ipAddressFieldType && remoteHostWhitelistExist }"
                      >{{ optionType.label }}</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </el-tooltip>
            </el-button-group>
          </div>
          <div slot="local-helper">
            <wizard-step-helper
              v-if="(!apiCalled && !whitelists.length) || (whitelists.models && whitelists.models.length === 0)"
              :helper-message="wizardHelper.message"
              :steps="wizardHelper.steps"
              :class="{ 'display-none': !showWizardHelper }"
            >
              <div slot="left-content-title" class="grid-content">
                <h6>Creating Your Own Whitelist</h6>
              </div>
              <div slot="action" class="grid-content">
                <el-dropdown @command="openWhitelistDialog" placement="bottom">
                  <el-button type="text" class="helper-action icon-text-button">
                    <i class="material-icons">add</i>
                    <span>New Whitelist</span>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="optionType in whitelistOptions"
                      :key="optionType.name"
                      :command="optionType.name"
                      :class="{ 'display-none': optionType.name === ipAddressFieldType && remoteHostWhitelistExist }"
                      >{{ optionType.label }}</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div slot="right-content-title" class="grid-content">
                <h6>Types of Customizable Whitelist</h6>
              </div>
              <div slot="right-grid-content" class="grid-content">
                <div v-for="(typeHelper, idx) in wizardHelper.whitelistTypeMessage" :key="idx">
                  <li>{{ typeHelper.title }}: {{ typeHelper.message }}</li>
                </div>
              </div>
            </wizard-step-helper>
          </div>
        </table-toolbar>
      </div>

      <action-table-element
        v-if="$allow('rules', 'write') && rulesWhitelistReqStatus === 'saved'"
        :columns="visibleWhitelistColumns"
        :table-data="whitelists"
        :height-offset="260"
        :actions="tableActions"
        ref="whitelistTable"
        @update-record-count="recordCountHandler"
        @popup-click="openColSelectionDialog"
      ></action-table-element>

      <basic-table-element
        v-if="!$allow('rules', 'write') && rulesWhitelistReqStatus === 'saved'"
        :columns="visibleWhitelistColumns"
        :table-data="whitelists"
        :height-offset="260"
        ref="whitelistTable"
        @update-record-count="recordCountHandler"
        @popup-click="openColSelectionDialog"
      ></basic-table-element>

      <el-dialog
        :title="`${dialogAction} ${newWhitelist.friendlyFieldName} Whitelist`"
        :visible.sync="whitelistDialogVisible"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        top="10vh"
      >
        <el-form :model="newWhitelist" :rules="newWhitelist.validationRules" ref="whitelistForm">
          <el-form-item label="Name" prop="name">
            <el-input v-model="newWhitelist.name" autocomplete="off" :disabled="dialogAction === 'Edit'"></el-input>
          </el-form-item>
          <el-collapse v-model="activeWhitelistFormItem" @change="accordionChange">
            <el-collapse-item
              id="collapse_values"
              :title="`Whitelisted ${newWhitelist.friendlyFieldName} (${newWhitelist.value.length})`"
              name="values"
            >
              <el-row class="custom-value-search">
                <el-input v-model="whitelistValueSearch" placeholder="Search">
                  <i slot="prefix" class="material-icons">search</i>
                </el-input>
              </el-row>
              <el-form-item prop="value">
                <el-row style="max-height: 160px; overflow: hidden scroll;">
                  <el-row
                    class="row-border list-row"
                    style="padding: 0px 10px;"
                    v-for="(val, idx) in queryWhitelistValue"
                    :key="idx"
                  >
                    <el-input
                      v-model="filteredWhiteList[idx].value"
                      :class="{ is_error: filteredWhiteList[idx].isError }"
                      @focus="onInputFocus(filteredWhiteList[idx])"
                      @blur="onInputBlur(val, filteredWhiteList[idx])"
                    >
                      <i
                        v-if="!filteredWhiteList[idx].isActive"
                        slot="suffix"
                        class="material-icons clear-input"
                        @click="
                          newWhitelist.removeValue(val)
                          $refs['whitelistForm'].validateField('value')
                        "
                        >delete</i
                      >
                      <i
                        @mousedown="changeVal(val, filteredWhiteList[idx], $event)"
                        class="material-icons clear-input"
                        slot="suffix"
                        v-if="filteredWhiteList[idx].isActive"
                        >done</i
                      >
                      <i
                        @mousedown="retainVal(val, filteredWhiteList[idx])"
                        class="material-icons clear-input"
                        slot="suffix"
                        v-if="filteredWhiteList[idx].isActive"
                        >close</i
                      >
                    </el-input>
                  </el-row>
                </el-row>
                <el-row class="row-border" style="padding: 10px 10px 0px 10px;">
                  <el-row>
                    <el-col :span="24" class="subtitle2">Add New</el-col>
                  </el-row>
                  <el-row class="custom-value-input">
                    <el-col :span="24">
                      <el-input
                        type="textarea"
                        :rows="3"
                        :placeholder="newWhitelist.valueHelpText"
                        v-model="newWhitelist.valueTextArea"
                      ></el-input>
                    </el-col>
                  </el-row>
                  <el-row class="custom-value-input">
                    <el-col :span="20">
                      <div class="image-upload">
                        <label for="file-input">
                          <i class="icon icon-file-upload"></i>
                          <input
                            id="ruleset_file"
                            type="file"
                            accept=".csv, .json"
                            ref="rulesetFile"
                            @change="handleFileUpload($event)"
                          />
                        </label>
                      </div>
                    </el-col>
                    <el-col :span="4" :push="2">
                      <span class="cursor-pointer add-button" @click="clearCommaSpaceSeparatedValues">
                        <i class="material-icons">close</i>
                      </span>
                      <span class="cursor-pointer add-button" @click="addCommaSpaceSeparatedValues">
                        <i class="material-icons">done</i>
                      </span>
                    </el-col>
                  </el-row>
                </el-row>
              </el-form-item>
            </el-collapse-item>
            <el-collapse-item
              id="collapse_rules"
              :title="
                `Rules Applied To (${newWhitelist.ruleIds ? newWhitelist.ruleIds.length : '0'}) ${
                  newWhitelist.field === ipAddressFieldType ? '*' : ''
                }`
              "
              name="rules"
            >
              <el-form-item prop="ruleIds" v-if="rulesListReqStatus === 'saved'">
                <el-row class="search-select-dropdown">
                  <span class="el-dropdown-link">
                    <el-input v-model="ruleSearch" placeholder="Search">
                      <i slot="prefix" class="material-icons">search</i>
                    </el-input>
                  </span>
                </el-row>
                <el-row class="search-select-dropdown" style="max-height: 250px; overflow: hidden auto;">
                  <el-row style="overflow-y: hidden;">
                    <el-dropdown-item
                      v-for="rule in queryRuleResults"
                      :key="rule.id"
                      :label="rule.id"
                      :value="rule.id"
                      :class="{
                        'display-none': !rule.display,
                        'row-selected': rule.selected && newWhitelist.field !== ipAddressFieldType
                      }"
                    >
                      <div @mouseleave="rule.showDetails = false">
                        <el-row>
                          <el-col :span="1" v-if="newWhitelist.field !== ipAddressFieldType">
                            <el-checkbox v-model="rule.selected"></el-checkbox>
                          </el-col>
                          <el-col :span="1">
                            <span class="icon icon-star" v-if="rule.ruleScore === 0 || rule.ruleScore === '0'"></span>
                            <span class="icon icon-skull" v-else></span>
                          </el-col>
                          <el-col :span="2">
                            <span>{{ rule.id }}</span>
                          </el-col>
                          <el-col :span="19">
                            <el-tooltip
                              class="item"
                              effect="dark"
                              :content="rule.name"
                              placement="top"
                              :enterable="false"
                            >
                              <span>{{ rule.name }}</span>
                            </el-tooltip>
                          </el-col>
                          <el-col :span="1">
                            <span class="float-right" @mouseover="rule.showDetails = true">
                              <i class="icon icon-arrow-down more-details float-right">arrow_drop_down_circle</i>
                            </span>
                          </el-col>
                        </el-row>
                        <el-row class="row-drawer" :class="{ 'display-none': !rule.showDetails }">
                          <el-row>
                            <span
                              class="display-block description body2"
                              v-for="(detail, idx) in rule.expressions"
                              :key="idx"
                              >{{ detail }}</span
                            >
                          </el-row>
                          <el-row>
                            <el-col :span="5">
                              <span class="display-inline-block">
                                <span class="subtitle2">Type:</span>
                                <span class="subtitle2">{{ rule.type }}</span>
                              </span>
                            </el-col>
                            <el-col :span="4">
                              <span class="display-inline-block">
                                <span class="subtitle2">Score:</span>
                                <span class="subtitle2">{{ rule.ruleScore }}</span>
                              </span>
                            </el-col>
                            <el-col :span="15">
                              <span class="display-inline-block">
                                <span class="subtitle2">Killchain Tactic:</span>
                                <cyber-kill-chain-tick-chart
                                  :chart-id="`${rule.id}`"
                                  :chart-data="rule.killChainData"
                                />
                                <span class="subtitle2">{{ rule.mitreAttackTactic.name }}</span>
                              </span>
                            </el-col>
                          </el-row>
                        </el-row>
                      </div>
                    </el-dropdown-item>
                  </el-row>
                </el-row>
                <el-row class="el-dropdown_footer">
                  <el-row style="line-height: 28px; vertical-align:bottom;">
                    <el-col :span="1" v-if="newWhitelist.field !== ipAddressFieldType">
                      <el-checkbox v-model="ruleCheckAll" @change="checkAllRuleChange"></el-checkbox>
                    </el-col>
                    <el-col :span="23">
                      <span class="float-left subtitle2" style="padding-left: 10px; overflow: hidden"
                        >Selected Rules ({{ selectedRulesDropdown.length }})</span
                      >
                    </el-col>
                  </el-row>
                </el-row>
              </el-form-item>
            </el-collapse-item>
          </el-collapse>
        </el-form>
        <span slot="footer">
          <el-row v-if="newWhitelist.field === ipAddressFieldType">
            <el-col :span="24">
              <span class="float-left subtitle2 asterisk-before"
                >For IP Address, the values provided will be applied to a fixed set of rules.</span
              >
            </el-col>
          </el-row>
          <el-row>
            <div v-if="whitelistFormError.error" class="error">
              <label>Error: {{ whitelistFormError.message }}</label>
            </div>
            <div v-if="whitelistDialogVisible && this.newWhitelist.fileUploadError.error" class="error">
              <label>Error: {{ this.newWhitelist.fileUploadError.message }}</label>
            </div>
            <el-button @click="whitelistDialogVisible = false">Cancel</el-button>
            <el-button @click="createWhitelist" type="primary">Confirm</el-button>
          </el-row>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { whitelistMetaInfo } from '@/column-header/allowlist/whitelist-meta'
import { RuleWhitelistHelperMessage, RuleWhitelistTypeMessage } from '@/constants/wizard-helper.constants'
import PageHeaders from '@/components/layout/PageHeaders.vue'
import TableToolbar from '@/components/table/TableToolbar.vue'
import BasicTableElement from '@/components/table/BasicTableElement.vue'
import ActionTableElement from '@/components/table/ActionTableElement.vue'
import CyberKillChainTickChart from '@/components/chart/CyberKillChainTickChart.vue'
import WizardStepHelper from '@/components/wizard/helper/WizardStepHelper.vue'

import {
  RULES_LIST_REQ,
  RULES_LIST_SUCCESS,
  RULES_WHITELIST_REQ,
  RULES_WHITELIST_REQ_SUCCESS,
  RULES_WHITELIST_CREATE_REQ,
  RULES_WHITELIST_DELETE_REQ
} from '@/store/modules/rules/rules.type'
import { MITRE_TACTIC_LIST_REQ, MITRE_TECHNIQUE_LIST_REQ } from '@/store/modules/mitre-attack/mitre-attack.type'
import {
  IP_ADDRESS_WHITELIST_FIELD_TYPE,
  IP_ADDRESS_WHITELIST_FRIENDLY_FIELD,
  PROCESS_WHITELIST_FIELD_TYPE,
  PROCESS_WHITELIST_FRIENDLY_FIELD
} from '@/constants/rules.constants'
import IPAddressRuleWhitelist from '@/resources/models/allowlist/IPAddressRuleWhitelist'
import ProcessRuleWhitelist from '@/resources/models/allowlist/ProcessRuleWhitelist'

export default {
  name: 'RulesWhitelist',
  data () {
    return {
      breadcrumbs: [{ title: 'Configuration' }, { title: 'Whitelist' }],
      ipAddressFieldType: IP_ADDRESS_WHITELIST_FIELD_TYPE,
      whitelistOptions: [
        {
          name: IP_ADDRESS_WHITELIST_FIELD_TYPE,
          label: IP_ADDRESS_WHITELIST_FRIENDLY_FIELD
        },
        {
          name: PROCESS_WHITELIST_FIELD_TYPE,
          label: PROCESS_WHITELIST_FRIENDLY_FIELD
        }
      ],
      showWizardHelper: true,
      wizardHelper: {
        message: RuleWhitelistHelperMessage,
        whitelistTypeMessage: RuleWhitelistTypeMessage,
        steps: ['Pick a white list type', 'Populate values', 'Select rules to apply']
      },
      apiCalled: false,
      combineRules: [],
      whitelists: {},
      whitelistColumns: whitelistMetaInfo.meta.columns,
      visibleWhitelistColumns: whitelistMetaInfo.meta.columns,
      dialogAction: 'Add',
      whitelistDialogVisible: false,
      activeWhitelistFormItem: ['values'],
      newWhitelist: { name: '', field: '', value: [], ruleIds: [] },
      selectedWhitelist: {},
      whitelistValueSearch: '',
      ruleSearch: '',
      ruleCheckAll: false,
      dialogTextArea: true,
      whitelistFormError: {
        error: false,
        message: ''
      },
      filteredWhiteList: [],
      preventBlur: false,
      tableActions: [
        {
          name: 'edit',
          icon: 'c-icon el-icon-edit',
          tooltip: 'Edit Whitelist',
          rbac: {
            subject: 'rules',
            operation: 'write'
          },
          actionHandler: selection => {
            this.editWhitelistDialog(selection.row)
          }
        },
        {
          name: 'copy',
          icon: 'c-icon material-icons',
          iconSubject: 'content_copy',
          tooltip: 'Copy Whitelist',
          rbac: {
            subject: 'rules',
            operation: 'write'
          },
          actionHandler: selection => {
            this.copyWhitelistDialog(selection.row)
          }
        },
        {
          name: 'delete',
          icon: 'c-icon el-icon-delete',
          tooltip: 'Delete Whitelist',
          rbac: {
            subject: 'rules',
            operation: 'write'
          },
          actionHandler: selection => {
            let vm = this
            this.$confirm(`This will delete ${selection.row.name}. Continue?`, 'Delete whitelist', {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              callback: function (action) {
                if (action === 'confirm') {
                  vm.deleteWhitelist(selection.row)
                } else if (action === 'cancel') {
                  vm.$message({
                    type: 'info',
                    message: `Operation canceled`
                  })
                }
              }
            })
          }
        }
      ]
    }
  },
  methods: {
    accordionChange (activeNames) {
      if (activeNames.length > 0) {
        let accordionElId = `#collapse_${activeNames[activeNames.length - 1]}`
        let collapseItem = this.$el.querySelectorAll(accordionElId)
        setTimeout(() => {
          collapseItem[0].scrollIntoView({
            behavoir: 'smooth',
            block: 'end',
            inline: 'start'
          })
        }, 500)
      }
    },
    addCommaSpaceSeparatedValues () {
      if (_.isEmpty(this.newWhitelist.valueTextArea)) {
        this.$refs['whitelistForm'].validateField('value')
      } else {
        let validValues = this.newWhitelist.parseCommaSpaceSeparatedValues(this.newWhitelist.valueTextArea)
        // case: whitelist values populated but additional entries are invalid
        if (_.isEmpty(validValues)) {
          let valueFieldValidator = _.find(this.$refs['whitelistForm'].fields, {
            prop: 'value'
          })
          valueFieldValidator.$el.classList.add('is-error')
          valueFieldValidator.validateState = 'error'
          if (this.newWhitelist.field === this.ipAddressFieldType) {
            valueFieldValidator.validateMessage = 'Invalid IPv4 CIDR format.'
          } else {
            valueFieldValidator.validateMessage = 'Invalid value format.'
          }
        } else {
          this.newWhitelist.value = this.newWhitelist.value.concat(validValues)
          this.clearCommaSpaceSeparatedValues()
        }
      }
    },
    clearCommaSpaceSeparatedValues () {
      if (!_.isEmpty(this.newWhitelist.valueTextArea)) {
        this.newWhitelist.valueTextArea = ''
        this.$refs['whitelistForm'].clearValidate('value')
      }
    },
    onInputFocus (item) {
      item.isActive = true
    },
    onInputBlur (prevValue, item) {
      if (!this.preventBlur) {
        item.value = prevValue
        item.isActive = false
      }
      this.preventBlur = false
    },
    changeVal (prevValue, item, ev) {
      item.isActive = false
      if (prevValue !== item.value) {
        this.newWhitelist.updateValue(prevValue, item.value)
        this.$refs['whitelistForm'].validateField('value')
        this.reRenderFilteredWhitelist()
      }
      this.preventBlur = true
    },
    retainVal (prevValue, item) {
      item.value = prevValue
      item.isActive = false
      this.preventBlur = true
    },
    reRenderFilteredWhitelist () {
      // recompute queryWhitelistValue
      if (!_.isEmpty(this.whitelistValueSearch)) {
        let tempwhitelistSearchVal = this.whitelistValueSearch
        this.whitelistValueSearch = ''
        this.whitelistValueSearch = tempwhitelistSearchVal
      } else {
        this.whitelistValueSearch = null
        this.whitelistValueSearch = ''
      }
    },
    clearPreviousSelection () {
      this.whitelistValueSearch = ''
      this.clearRulesSelection()
      this.checkAllRuleChange(false)
    },
    selectNewWhitelistType (whitelistType) {
      switch (whitelistType) {
        case IP_ADDRESS_WHITELIST_FIELD_TYPE:
          let ipWhitelist = new IPAddressRuleWhitelist('key', this.newWhitelist)
          ipWhitelist.selectNetworkRules(this.combineRules)
          return ipWhitelist
        default:
          return new ProcessRuleWhitelist('key', this.newWhitelist)
      }
    },
    openColSelectionDialog ({ row, col }) {
      this.editWhitelistDialog(row)
      if (col === 'rulesCount') {
        this.activeWhitelistFormItem = ['rules']
        this.$nextTick(() => {
          this.accordionChange(['rules'])
        })
      }
    },
    openWhitelistDialog (menuItem) {
      this.$set(this, 'dialogAction', 'Add')
      this.activeWhitelistFormItem = ['values']
      this.clearPreviousSelection()
      this.$set(this, 'newWhitelist', this.selectNewWhitelistType(menuItem))
      if (this.$refs['whitelistForm']) {
        if (!_.isUndefined(this.newWhitelist.valueTextArea)) {
          this.newWhitelist.valueTextArea = ''
        }
        this.newWhitelist.clearInputProperties()
        this.$nextTick(() => {
          this.$refs['whitelistForm'].clearValidate(['name', 'value', 'ruleIds'])
        })
      }
      this.$nextTick(() => {
        this.newWhitelist.ruleIds.forEach(rule => {
          this.checkRule(rule, true)
        })
        if (this.newWhitelist instanceof IPAddressRuleWhitelist) {
          this.hideUnselectedRules()
        }
      })
      this.whitelistDialogVisible = true
    },
    copyWhitelistDialog (selection) {
      if (selection.field === this.ipAddressFieldType) {
        this.$msgbox({
          title: `Copy ${selection.friendlyFieldName} Whitelist`,
          message: `You can create only one IP Whitelist.`,
          showCancelButton: false,
          confirmButtonText: 'OK'
        })
        return false
      }
      this.$set(this, 'dialogAction', 'Copy')
      this.clearPreviousSelection()
      this.activeWhitelistFormItem = ['values']
      this.newWhitelist = _.cloneDeep(selection)
      this.newWhitelist.name = `${this.newWhitelist.name}_1`
      this.newWhitelist.transformRuleIds(this.combineRules)
      this.whitelistDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs['whitelistForm']) {
          this.$refs['whitelistForm'].clearValidate(['name', 'value', 'ruleIds'])
        }
        this.newWhitelist.ruleIds.forEach(rule => {
          this.checkRule(rule, true)
        })
        if (this.newWhitelist instanceof IPAddressRuleWhitelist) {
          this.hideUnselectedRules()
        }
      })
    },
    editWhitelistDialog (selection) {
      this.$set(this, 'dialogAction', 'Edit')
      this.clearPreviousSelection()
      this.activeWhitelistFormItem = ['values']
      this.newWhitelist = _.cloneDeep(selection)
      this.newWhitelist.transformRuleIds(this.combineRules)
      this.whitelistDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs['whitelistForm']) {
          this.$refs['whitelistForm'].clearValidate(['name', 'value', 'ruleIds'])
        }
        this.newWhitelist.ruleIds.forEach(rule => {
          this.checkRule(rule, true)
        })
        if (this.newWhitelist instanceof IPAddressRuleWhitelist) {
          this.hideUnselectedRules()
        }
      })
    },
    callApi (tableMetaData) {
      this.apiCalled = true
      this.$store.dispatch(RULES_WHITELIST_REQ).then(whitelist => {
        this.whitelists = this.rulesWhitelist
        this.$store.dispatch(RULES_WHITELIST_REQ_SUCCESS)
        this.setTableMetaData(tableMetaData)
        this.apiCalled = false
        if (this.whitelists.models.length > 0) {
          this.showWizardHelper = false
        }
      })
    },
    updateTableQueryData () {
      if (this.$refs['whitelistTable']) {
        this.$refs['whitelistTable'].updateTableData()
      }
    },
    recordCountHandler () {
      // key is used to re-render TableToolbar component
      // on page change to update 'queryCountText'
      this.whitelists.key = !this.whitelists.key
      this.whitelists.reloadToolbar = false
    },
    modifyColumnsData (selectedColumns) {
      this.visibleWhitelistColumns = this.whitelists.updateVisibleColumns(this.whitelistsColumns, selectedColumns)
    },
    setTableMetaData (tableMetaData) {
      this.whitelists.searchTags = tableMetaData.searchTags
      this.whitelists.currentPage = tableMetaData.activePage
    },
    refreshTableData (tableMetaData) {
      this.callApi(tableMetaData)
    },
    handleFileUpload (event) {
      let file = this.$refs.rulesetFile.files[0]
      // parse only if a file is selected
      if (file) {
        this.newWhitelist.importCsvValues(event, file)
      }
      // clear target value to accpet same file again
      event.target.value = ''
    },
    hideUnselectedRules () {
      this.combineRules.forEach(rule => {
        if (!rule.selected) {
          rule.display = false
        }
      })
    },
    markRulesVisible (queryStr) {
      this.combineRules.forEach(rule => {
        rule.display = false
        if (_.isEmpty(queryStr) || rule.name.toLowerCase().includes(queryStr.toLowerCase())) {
          rule.display = true
        }
      })
    },
    checkRule (rule, val) {
      let foundRule = _.findIndex(this.queryRuleResults, {
        id: rule.id || rule
      })
      if (foundRule > -1) {
        this.$set(this.queryRuleResults[foundRule], 'selected', val)
      }
    },
    checkAllRuleChange (val) {
      this.queryRuleResults.forEach((rule, idx) => {
        this.$set(this.queryRuleResults[idx], 'selected', val)
      })
      this.ruleCheckAll = val
    },
    clearRulesSelection () {
      this.ruleSearch = ''
      this.markRulesVisible('')
    },
    applyRulesSelection () {
      this.newWhitelist.ruleIds = _.filter(this.combineRules, {
        selected: true
      })
    },
    createWhitelist () {
      this.whitelistFormError.error = false
      this.newWhitelist.fileUploadError.error = false
      this.applyRulesSelection()

      // check if name is a duplicate
      if (this.dialogAction === 'Add' && _.some(this.whitelists.models, { key: this.newWhitelist.name })) {
        this.whitelistFormError.error = true
        this.whitelistFormError.message = 'Whitelist name already exists.'
        return false
      }
      // check for duplicate values
      let duplicateVals = _.uniq(
        _.filter(this.newWhitelist.value, (val, idx, valueList) => valueList.indexOf(val) !== idx)
      )
      if (duplicateVals.length > 0) {
        this.whitelistFormError.error = true
        this.whitelistFormError.message = `Duplicate values (${duplicateVals.join(', ')})`
        return false
      }

      // check if rules are selected
      if (this.newWhitelist.ruleIds.length === 0) {
        this.whitelistFormError.error = true
        this.whitelistFormError.message = `Please select the whitelist rules.`
        return false
      }

      this.$refs['whitelistForm'].validate(valid => {
        if (valid) {
          this.$store.dispatch(RULES_WHITELIST_CREATE_REQ, [this.newWhitelist.preparePostbody()]).then(
            () => {
              this.refreshTableData({
                searchTags: this.whitelists.searchTags,
                activePage: this.whitelists.currentPage || 1
              })
              this.$message({
                type: 'success',
                message: 'Whitelist successfully created.'
              })
              this.whitelistDialogVisible = false
            },
            errMsg => {
              this.$message({
                type: 'error',
                message: 'Error creating whitelist.'
              })
            }
          )
        }
      })
    },
    deleteWhitelist (sel) {
      this.$store.dispatch(RULES_WHITELIST_DELETE_REQ, sel).then(
        () => {
          this.refreshTableData({
            searchTags: this.whitelists.searchTags,
            activePage: this.whitelists.currentPage
          })
          this.$message({
            type: 'success',
            message: 'Whitelist successfully removed.'
          })
          this.whitelistDialogVisible = false
        },
        errMsg => {
          this.$message({
            type: 'error',
            message: 'Error removing whitelist.'
          })
        }
      )
    }
  },
  created () {
    let tableMetaData = {
      activePage: 1,
      searchTags: []
    }
    if (this.rulesListReqStatus !== 'saved') {
      Promise.all([this.$store.dispatch(MITRE_TACTIC_LIST_REQ), this.$store.dispatch(MITRE_TECHNIQUE_LIST_REQ)]).then(
        values => {
          this.$store.dispatch(RULES_LIST_REQ).then(rules => {
            this.$store.dispatch(RULES_LIST_SUCCESS)
            this.combineRules = _.cloneDeep(this.allRulesList).sort((a, b) => {
              a.showDetails = false
              a.display = true
              b.showDetails = false
              b.display = true
              return parseInt(a.id) - parseInt(b.id)
            })

            this.combineRules = _.filter(this.combineRules, rule => {
              return (_.isUndefined(rule.deprecated) || rule.deprecated === false) && rule.tactic
            })

            this.callApi(tableMetaData)
          })
        }
      )
    } else {
      this.combineRules = _.cloneDeep(this.allRulesList).sort((a, b) => {
        a.showDetails = false
        a.display = true
        b.showDetails = false
        b.display = true
        return parseInt(a.id) - parseInt(b.id)
      })

      this.combineRules = _.filter(this.combineRules, rule => {
        return (_.isUndefined(rule.deprecated) || rule.deprecated === false) && rule.tactic
      })
      this.callApi(tableMetaData)
    }
  },
  computed: {
    queryWhitelistValue () {
      let filteredList = _.filter(this.newWhitelist.value, val => {
        return val.toLowerCase().includes(this.whitelistValueSearch.toLowerCase())
      })
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.filteredWhiteList.length = 0
      filteredList.forEach((val, idx) => {
        let tempObj = {
          value: val,
          isActive: false,
          isError: false
        }
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.filteredWhiteList.push(tempObj)
      })
      return filteredList
    },
    selectedRulesDropdown () {
      return _.filter(this.combineRules, { selected: true })
    },
    queryRuleResults () {
      this.markRulesVisible(this.ruleSearch)
      return this.combineRules
    },
    ...mapGetters([
      'rulesWhitelistReqStatus',
      'rulesWhitelist',
      'remoteHostWhitelistExist',
      'rulesListReqStatus',
      'rulesList',
      'privilegedRulesList',
      'allRulesList'
    ])
  },
  components: {
    PageHeaders,
    ActionTableElement,
    TableToolbar,
    BasicTableElement,
    CyberKillChainTickChart,
    WizardStepHelper
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import 'assets/styles/_variables.css';

.table-toolbar {
  button {
    max-height: 36px;
  }
}

.error {
  text-align: center;
  color: var(--text-color-danger);
}

.el-dialog__wrapper {
  overflow: unset;
}

.el-dialog__wrapper >>> .el-dialog__body {
  overflow: auto;
  height: 400px;
}

.icon-text-button {
  background: var(--main-blue);
  padding: 5px 10px;

  span {
    .c-icon {
      color: white;
      font-size: 1.2em;
      vertical-align: text-bottom;
      margin-right: 5px;
    }
    span {
      color: white;
      margin-bottom: 6px;
    }
  }
}

.help-text-button {
  line-height: 28px;
  padding: 0px;
}

.material-icons {
  vertical-align: middle;
  color: var(--gray-500);
}

>>> .el-dialog__body {
  .el-select {
    width: 100%;
  }

  .el-dropdown {
    width: 100%;
    box-sizing: border-box;
    background-color: white;
    background-image: none;
    border: none;

    .el-select {
      color: var(--border-color);
      border: 1px solid var(--border-color);
      opacity: 0.8;
      height: 40px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 660px;

      &:focus,
      &.focusing {
        border-color: #409eff;
        outline: 0;
      }

      > span {
        padding-left: 10px;
      }
      > i {
        padding-right: 10px;
      }
    }

    .el-icon-arrow-down {
      vertical-align: bottom;
      line-height: 40px;
      margin-right: 24px;
    }
  }
}

.icon-arrow-down {
  mask-repeat: no-repeat;
  mask-size: cover;
  vertical-align: middle;
  line-height: 36px;
  height: 14px;
  width: 14px;
  margin-top: 10px;
}

.icon-skull,
.icon-star,
.icon-file-upload {
  display: inline-block;
  vertical-align: middle;
  mask-repeat: no-repeat;
  mask-size: cover;
  margin: 0px 5px;
}

.icon-skull,
.icon-star {
  height: 14px;
  width: 14px;
}

.icon-skull {
  background: var(--main-amaranth);
}

.icon-star {
  background: var(--main-blue);
}

.el-dropdown-link .material-icons {
  line-height: 40px;
}

.el-dropdown_footer {
  padding: 10px 20px 10px;
  border: 1px solid var(--border-color);

  .material-icons {
    line-height: 26px;
    border: 1px solid var(--border-color);
  }

  .el-col {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 500px;
  }
}

.el-divider--vertical {
  margin: 0px;
}

.search-select-dropdown {
  >>> .el-input__inner {
    border-radius: 0px;
  }

  >>> .el-dropdown-menu__item {
    padding: 0px;

    > div {
      border: 1px solid var(--border-color);
      border-top: 0px;
    }

    &:hover {
      background-color: #f5f7fa;
      color: inherit;
    }

    &.row-selected {
      background: var(--denim-50) !important;
    }

    > span {
      vertical-align: middle;
    }

    .description {
      max-width: 600px;
      word-break: break-word;
      line-height: 20px;
    }

    .el-row {
      padding: 0px 20px;

      &.row-drawer {
        background: white;
      }
    }

    .el-col-19 {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}

.row-border {
  border: 1px solid var(--border-color);

  &.list-row {
    border-bottom: 0px;
  }
}

.image-upload {
  .icon-file-upload {
    background: var(--gray-500);
  }

  #ruleset_file {
    z-index: 99;
    opacity: 0;
    height: 20px;
    position: relative;
    left: -120px;
    cursor: pointer;
  }
}

.custom-value-search {
  >>> .el-input__inner {
    border-radius: 0px;
    border-bottom: 0px;
  }

  .material-icons {
    line-height: 40px;
  }
}

.el-form-item:not(.is-error) {
  .custom-value-input {
    >>> .el-input__inner,
    >>> .el-textarea__inner {
      font-family: var(--main-font-family);
      border: 1px solid var(--border-color);
      border-radius: 0px;
      word-break: keep-all;
    }
  }
}

.el-form-item.is-error {
  .custom-value-input {
    >>> .el-input__inner,
    >>> .el-textarea__inner {
      font-family: var(--main-font-family);
      border-radius: 0px;
      word-break: keep-all;
    }
  }
}

.custom-value-input {
  &.el-row {
    padding-top: 10px;
  }

  .add-button {
    line-height: 25px;

    .material-icons {
      font-size: 1.5em;
      vertical-align: middle;
    }
  }
}

.helper-action.icon-text-button {
  width: 100%;
  background: white;
  color: var(--denim-600);
  padding: 0px 10px;

  i,
  span {
    color: var(--denim-600);
  }
}

.clear-input {
  cursor: pointer;
  margin-left: 8px;
}

.list-row {
  >>> .el-input__inner {
    border: none;
  }
}

>>> .el-collapse-item__header {
  height: 40px;
  line-height: 40px;
  background-color: var(--gray-50);
  border-bottom: 1px solid var(--border-color);
  padding-left: 15px;
  font-size: 10px;
  font-weight: normal;
  color: inherit;
  line-height: 32px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

>>> .el-collapse-item__content {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/RulesWhitelist.vue